import $api from '@/api'
import {
  getToken,
  setToken,
  removeToken,
  setAccountCode,
  setTelNumber
} from '@/utils/auth'
import { resetRouter } from '@/router'

const getDefaultState = () => {
  return {
    userInfo: {},
    auditStatus: '',
    userId: '',
    token: getToken(),
    name: '',
    realName: '',
    unionCode: '',
    avatar: '',
    telNumber: '',
    role: {},
    businessCode: '',
    advisorCode: '',
    companyCode: '',
    companyName: '',
    departmentName: '',
    accountAccessType: '',
    waterMarkStr: '' // 图片水印
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, obj) => {
    state.token = obj.token
    state.platformToken = obj.advisorToken
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_TEL_NUMBER: (state, telNumber) => {
    state.telNumber = telNumber
  },
  SET_ROLE: (state, role) => {
    state.role = role || {}
  },
  SET_COMPANY_NAME: (state, companyName) => {
    state.companyName = companyName
  },
  SET_BUSINESS_CODE: (state, businessCode) => {
    state.businessCode = businessCode
  },
  SET_ADVISOR_CODE: (state, advisorCode) => {
    state.advisorCode = advisorCode
  },
  SET_WATER_MARK_STR: (state, waterMarkStr) => {
    state.waterMarkStr = waterMarkStr
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
  }
}

const actions = {
  login({ dispatch, commit }, loginInfo) {
    return new Promise((resolve, reject) => {
      $api
        .login(loginInfo)
        .then((response) => {
          const { jwtUserStr, accountCode } = response.data
          setToken(jwtUserStr)
          setAccountCode(accountCode)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  resetLogin({ dispatch, commit }, loginInfo) {
    return new Promise((resolve, reject) => {
      $api
        .postAccountRenewPwd(loginInfo)
        .then((response) => {
          const { jwtUserStr, accountCode } = response.data
          setToken(jwtUserStr)
          setAccountCode(accountCode)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // user logout
  logout({ commit, state }, loginInfo) {
    return new Promise((resolve, reject) => {
      $api.loginOut(loginInfo).then(() => {
        removeToken() // must remove  token  first
        commit('RESET_STATE')
        resetRouter()
        /** 清除所有sessionStorage */
        // 延迟删除，避免删除后再保存
        setTimeout(() => {
          sessionStorage.clear()
        }, 1000)
        resolve()
      })
    })
  },

  setUserInfo({ dispatch, commit }, userInfo) {
    commit('SET_USER_INFO', userInfo)
    setTelNumber(userInfo.telNumber)
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken() // must remove  token  first
      resolve()
    })
  },

  // 获取水印
  getWaterMark({ commit }) {
    return $api.getWatermarkParamStr().then((res) => {
      if (res.code == 200) {
        commit('SET_WATER_MARK_STR', res.data)
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
